import { MappedGolfCourseType } from './types';

export default function getGolfCourseUrl(course?: MappedGolfCourseType): string {
  if (!course) {
    return '';
  }

  return `${course.golfClub.name}/${course.golfCourse.name}/`;
}
